module.exports = __webpack_public_path__ + "static/media/template_project.30b4112f.csv";